export default __webpack_public_path__ + "static/media/human-cardio.7a21f8e4.svg";